import { COLOR } from '@src/styles/color';
import { styled } from '@mui/material/styles';
import { Card } from '@mui/material';

const StyledPackage = styled('div')`
  width: 100%;
  max-width: 368px;
  height: 100%;
  border-radius: 24px;
  padding: 24px;
  background: #f4f5f7;
  border: 1px dashed #1e164e29;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    padding: 16px 8px;
  }

  .tab-group-wrapper {
    padding: 4px;
    background-color: #1e164e0a;
    border-radius: 500px;
    box-sizing: border-box;
    height: 40px;
    display: flex;
    margin: 16px auto;
    align-items: center;
    justify-content: ${(props) => {
      if (props.useRenameMergeProduct && props.isMobile) return 'unset';
      return props.isMobile ? 'space-between' : 'unset';
    }};
    width: ${(props) => (props.isMobile ? '348px' : 'max-content')};
    @media only screen and (max-width: 400px) {
      width: ${(props) => props.isMobile && '340px'};

      .tabs {
        font-size: 14px !important;
      }
      .tabs-active {
        font-size: 14px !important;
      }
    }
    .tabs {
      color: #1c1c1ea3;
      cursor: ${(props) =>
        props.disabledTab ? 'not-allowed' : 'pointer'} !important;
    }
    .tabs,
    .tabs-active {
      padding: 4px 8px;
      font-size: 14px;
      height: 32px;
      font-weight: 500;
      box-sizing: border-box;
      color: #1c1c1e;
      cursor: pointer;
      border-radius: 500px;
      display: flex;
      gap: 5px;
      align-items: center;
      justify-content: center;
      flex: ${(props) => props.isMobile && 0.5};
      white-space: nowrap;

      .save {
        background-color: #ffd60a;
        padding: 4px 8px;
        border-radius: 500px;
        font-size: 12px;
        font-weight: 500;
        color: #1e164e;
      }

      .no-save {
        width: 0px;
        height: 28px;
      }
    }

    .tabs {
      color: #1e164e7a;
    }

    .tabs-active {
      box-shadow: 0px 4px 48px 0px rgba(0, 0, 0, 0.16);
      color: ${COLOR.darkBlue};
    }

    .pr-4 {
      padding-right: 4px;
    }

    .tabs {
      background-color: transparent;
    }

    .tabs-active {
      background-color: #ffffff;
    }
  }
`;

const StyledNewPackageItemWrapper = styled('div')`
  box-shadow: 0px 2px 16px 0px #ffffff14;
  width: 320px;
  background-color: ${(props) => !props.isPoppular && COLOR.white};
  position: relative;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  ${({ isPoppular }) =>
    isPoppular &&
    `background-image: url('https://media-frontend.vbee.vn/images/package/special-package-bg.webp');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: top;`}
`;

const StyledNewPackageItemV2 = styled(Card)`
  .card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  display: flex;
  flex-direction: column;
  flex: 1;
  border: ${(props) =>
    props.isPoppular ? '0.5px solid #ffd60a' : '0.5px solid #1e164e29'};
  box-shadow: none;
  overflow: visible;
  padding: 20px;
  border-radius: 24px;
  background-color: ${(props) =>
    props.isPoppular ? 'transparent' : COLOR.white};

  .credit-slider-and-package-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex-grow: 1;
    justify-content: flex-end;
  }

  .card-pacakge-main-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .card-package {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .popularity {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    background: ${COLOR.yellow[16]};
    padding: 2px;
    padding-left: 12px;
    border-radius: ${(props) => (props.isMobile ? '8px' : '0px 0px 12px 12px')};

    .popularity-text {
      font-size: 12px;
    }
  }

  .price-package {
    display: flex;
    align-items: center;
    letter-spacing: -1.4px;
  }

  .price-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 0px;
  }

  .original-price-wrapper {
    display: flex;
    align-items: center;
    height: 20px;
  }

  .price-original-discount {
    .discount-unit-price {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.4px;
      color: ${COLOR.label2[64]};
      text-transform: lowercase;
      padding-bottom: -2px;
    }
  }

  .original-price,
  .original-price-not-line-through {
    font-size: 14px;
    font-weight: 400;
    line-height: 32px;
    white-space: nowrap;
    color: ${COLOR.lightText};
  }

  .original-price-not-line-through {
    text-decoration: none;
    margin-left: -6px;
  }

  .package-price-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .price {
    display: flex;
    align-items: center;
  }

  .three-first {
    font-size: 32px;
    font-weight: 800;
    line-height: 46px;
    letter-spacing: -0.4px;
    color: ${COLOR.label2[100]};
  }

  .three-last {
    font-size: 20px;
    font-weight: 800;
    line-height: 28px;
    letter-spacing: -0.4px;
    color: ${COLOR.label2[100]};
  }

  .unit-price {
    font-weight: 510;
    font-size: 16px;
    line-height: 24px;
    color: ${COLOR.label2[100]};
    text-transform: lowercase;
    padding-bottom: -2px;
  }

  .original-price {
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${COLOR.label2[64]};
  }

  .original-price-month {
    font-size: 14px;
    white-space: nowrap;
    text-decoration: line-through;
    color: ${COLOR.lightText};
  }

  .original-price-unit {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${COLOR.label2[64]};
  }

  .font-size-14 {
    font-size: 14px !important;
  }

  .underlined {
    text-decoration: underline;
  }

  .sub-origin-price {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${COLOR.label2[64]};
  }

  .buy-package-btn-container {
    min-height: 80px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: auto;
  }

  .button-start {
    font-weight: bold;
    border-radius: ${(props) =>
      props.highlight && props.isPoppular ? '12px 12px 0px 0px' : '12px'};
    opacity: ${(props) => (props.isDisableButton ? '0.5' : '1')};
    border-color: ${COLOR.indigo[16]};
    color: ${COLOR.indigo[100]};
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: -0.4px;
    text-transform: none;
    height: 48px;
    padding: 12px 16px;
    box-sizing: border-box;
    pointer-events: ${(props) => props.isDisableButton && 'none'};

    &.MuiButton-outlined:not(.button-highlight):hover {
      background: #f9fafb;
      border-color: ${COLOR.indigo[16]};
    }
  }

  .button-slider-credits {
    margin-top: 81px !important;
  }

  .button-highlight {
    background: ${COLOR.primary};
    color: ${COLOR.darkBlue};
    border-color: ${COLOR.primary};
  }

  .description-package {
    color: ${COLOR.label2['64']};
    font-weight: 400;
    font-size: 14px;
    height: 42px;
    letter-spacing: -0.4;
  }
`;

export { StyledPackage, StyledNewPackageItemWrapper, StyledNewPackageItemV2 };
